import React, { memo } from "react";
import { TextField } from "@swiggy-private/dls-web-core/dist/components/TextField";
import { RightActionTypes, TextFieldTypes } from "@swiggy-private/dls-web-core/dist/components/TextField/types";

interface InputFieldProps {
    id: string;
    label: string;
    enabled: boolean;
    value?: string;
    onChange: (fieldId: string, value: string) => void;
    isDetailsSubmitted?: boolean;
}

const InputFieldComponent: React.FC<InputFieldProps> = ({ id, label, value, onChange, isDetailsSubmitted }) => {
    return (
        <TextField
            key={id}
            textFieldDetails={{
                value: value || "",
                label: label,
                name: id,
                type: TextFieldTypes.TEXT,
                onChange: (newValue: string) => onChange(id, newValue),
                attrs: {
                    disabled: isDetailsSubmitted,
                    autoComplete: "off",
                    "data-testid": `${id}-input`,
                },
            }}
            rightActionDetails={[
                {
                    type: RightActionTypes.CLEAR,
                },
            ]}
        />
    );
};

export default memo(InputFieldComponent);
